import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component SearchLargeIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <SearchLargeIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <SearchLargeIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const SearchLargeIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      data-testid="SearchLargeIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M14 4c5.523 0 10 4.477 10 10 0 2.31-.783 4.436-2.098 6.129q.132.06.248.15l.126.111 5.334 5.334a1.333 1.333 0 0 1-1.76 1.996l-.126-.11-5.334-5.334a1.3 1.3 0 0 1-.263-.373A9.95 9.95 0 0 1 14 24C8.477 24 4 19.523 4 14S8.477 4 14 4m0 2.667a7.333 7.333 0 1 0 0 14.666 7.333 7.333 0 0 0 0-14.666"
        clipRule="evenodd"
      />
    </svg>
  )
);
SearchLargeIcon.displayName = "SearchLargeIcon";
export default SearchLargeIcon;
